import React from 'react'
import { BrowserRouter as Router, Route, Link } from "react-router-dom"
import Topics from './scenes/topics'
import Topic from './scenes/topics/edit'

export default () =>    <div>
                            <Route path="/" exact component={Topics} />
                            <Route path="/topic/:id" component={Topic}></Route>
                        </div>
                        